// The page's copy of functions/bulkOrders.js paidQty/owedQty — CRA cannot
// import from outside src. bulkOrderPaid.test.js holds the two to one answer.
//
// How many of a group-order row's items are paid for. Rows ticked before
// quantityPaid existed have only `paid`, which meant all of them.
export function paidQty(row) {
  const r = row || {};
  if (r.quantityPaid !== undefined && r.quantityPaid !== null && Number.isFinite(Number(r.quantityPaid))) {
    return Math.max(0, Math.floor(Number(r.quantityPaid)));
  }
  return r.paid === true ? Math.max(0, Math.floor(Number(r.quantity) || 0)) : 0;
}

/** What is still owed on a row, in items. Never negative. */
export function owedQty(row) {
  return Math.max(0, (Number(row?.quantity) || 0) - paidQty(row));
}
